import { Link } from "react-router-dom";
import "../styles/privacy-policy.css";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page">
       <div className="privacy-policy-hero">
        <div className="privacy-policy-hero__content">
          <h1 className="privacy-policy-title">Privacy Policy</h1>
        </div>
      </div>
      <div className="container">
        <nav className="privacy-policy-breadcrumb">
          <Link to="/" className="privacy-policy-breadcrumb-link">Home</Link>
          <span className="privacy-policy-breadcrumb-separator">/</span>
          <span className="privacy-policy-breadcrumb-current">Privacy Policy</span>
        </nav>
      </div>

      {/* <div className="privacy-policy-hero">
        <div className="privacy-policy-hero__content">
          <h1 className="privacy-policy-title">Privacy Policy</h1>
        </div>
      </div> */}

      <div className="container">
        <div className="privacy-policy-content-wrapper">
          <div className="privacy-policy-content">
            <p className="privacy-policy-paragraph">
              At AmpsTek, we prioritize data privacy and the trust we build with our customers and partners. We understand the importance of safeguarding your personal information and are dedicated to handling it responsibly, in accordance with relevant data protection laws in every country where AmpsTek operates.
            </p>

            <p className="privacy-policy-paragraph">
              This Privacy Statement outlines AmpsTek's general practices regarding the personal information we collect, use, and share about consumers and individuals associated with our clients, business partners, suppliers, and other organizations with which AmpsTek has or is considering a business relationship.
            </p>

            <p className="privacy-policy-paragraph">
              Additionally, this statement provides more information in the online context, including recruitment. We may offer further details on the collection or use of personal information on specific websites or in relation to particular products or services.
            </p>

            <h2 className="privacy-policy-heading">Information We Collect and How We Use It</h2>

            <p className="privacy-policy-paragraph">
              We may gather your personal information for various purposes, including:
            </p>

            <h3 className="privacy-policy-subheading">Accessing and Using Our Websites</h3>

            <p className="privacy-policy-paragraph">
              When you visit one of our websites or use an online service, we collect necessary information to grant you access, ensure the website operates smoothly, and comply with security and legal requirements. This may include passwords, IP addresses, and browser settings. We also track your activities during your visit to personalize your experience, such as saving your preferences and settings, and to gather statistics to enhance our websites, products, and services.
            </p>

            <h3 className="privacy-policy-subheading">Responding to Your Inquiries</h3>

            <p className="privacy-policy-paragraph">
              When you reach out to us (online or offline) for information about our solutions or products, to place an order, to request support, or to engage in a forum or social computing tool, we collect information essential to fulfill your request. This includes your name, contact details, specifics about your inquiry, as well as details related to order fulfillment, delivery, and invoicing. We may also gather feedback through client satisfaction surveys and retain this information for administrative purposes and to maintain our relationship with you.
            </p>

            <p className="privacy-policy-paragraph">
              If you register with us while making such a request, this registration may help identify you during future visits to our website.
            </p>

            <h3 className="privacy-policy-subheading">Contacting Employees of Clients, Prospects, Partners, and Suppliers</h3>

            <p className="privacy-policy-paragraph">
              In our interactions with clients, prospects, partners, and suppliers, we may receive business contact information (such as name, contact details, and job title) for purposes such as contract management, product and service delivery, support, invoicing, and relationship management.
            </p>

            <h3 className="privacy-policy-subheading">Visitor Information</h3>

            <p className="privacy-policy-paragraph">
              We record information about individuals visiting our locations (including name, identification, and business contact details) and may use surveillance cameras for security and safety, as well as for compliance with regulatory requirements.
            </p>

            <h3 className="privacy-policy-subheading">Marketing</h3>

            <p className="privacy-policy-paragraph">
              The majority of the information we collect about you comes from direct interactions. When you register for an event, we may gather relevant information (online or offline) related to event organization, including participation in sessions and survey results. We combine this personal information to develop aggregate analyses and business intelligence for our operations and marketing efforts. You can opt to receive information about our products and services via email, phone, or postal mail, or subscribe to our updates. During your visits to our website or while using our services, we may provide you with personalized information. You can always opt out of personalized communications by emailing us.
            </p>

            <p className="privacy-policy-paragraph">
              When we refer to using your personal information for a request, order, transaction, or agreement (or in preparation for the same), or to provide services you have requested, this is necessary for fulfilling our agreement with you.
            </p>

            <h2 className="privacy-policy-heading">Sharing Your Personal Information</h2>

            <p className="privacy-policy-paragraph">
              Where appropriate, AmpsTek may share your personal information with selected partners or employees in other countries to assist in providing products or services, fulfilling your requests, or with your consent. When choosing our suppliers and partners, we consider their data handling practices.
            </p>

            <p className="privacy-policy-paragraph">
              Please note that in certain situations, personal information may need to be disclosed to government agencies under judicial proceedings, court orders, or legal processes. We may also share your information to protect the rights or property of AmpsTek, our business partners, suppliers, or clients, when we have reasonable grounds to believe such rights or property are at risk.
            </p>

            <h2 className="privacy-policy-heading">Information Security and Accuracy</h2>

            <p className="privacy-policy-paragraph">
              We strive to protect your personal information and maintain its accuracy. AmpsTek implements reasonable physical, administrative, and technical safeguards to protect your information from unauthorized access, use, and disclosure. For example, we may encrypt sensitive information, such as credit card data, when transmitted over the internet, and ensure that access is limited to authorized personnel. We also require our suppliers to safeguard this information against unauthorized access, use, and disclosure.
            </p>

            <h2 className="privacy-policy-heading">Retention Period</h2>

            <p className="privacy-policy-paragraph">
              We will not retain personal information longer than necessary to fulfill the purposes for which it was collected, including ensuring compliance with legal and regulatory obligations (e.g., audits, accounting, and statutory retention terms), resolving disputes, and for establishing, exercising, or defending legal claims in the countries where we operate.
            </p>

            <h2 className="privacy-policy-heading">How to Contact Us</h2>

            <p className="privacy-policy-paragraph">
              If you have questions regarding this Privacy Statement, please reach out via email at <a href="mailto:info@ampstek.com" className="privacy-policy-link">info@ampstek.com</a>. Your message will be forwarded to the appropriate member of the AmpsTek Data Privacy Team.
            </p>

            <h2 className="privacy-policy-heading">Your Rights</h2>

            <p className="privacy-policy-paragraph">
              You have the right to access, update, delete, or correct your personal information. You can also object to direct marketing. Requests can be made via the email addresses provided on our website.
            </p>

            <h2 className="privacy-policy-heading">Changes to Our Privacy Statement</h2>

            <p className="privacy-policy-paragraph">
              We may update this Privacy Statement periodically to reflect changes in our data governance practices. The revised statement will be posted here with an updated revision date. We encourage you to check back regularly for updates. If we make significant changes, we will post a notice at the top of this page for 30 days. Continuing to use our website after such changes indicates that you have read and understood the updates.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
